// import { useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './components/global/footer/Footer';
import Sidebar from './components/global/sidebar';
import MainDashboard from './pages/dashboard';
import InvestmentDetails from './pages/investments/investment-details';
import ProfilePage from './pages/profile';
import EditProfile from './pages/profile/edit-profile';
import UpdatePassword from './pages/profile/update-password';
import Withdrawals from './pages/withdrawals';
import BankListPage from './pages/banks';
import AddBankPage from './pages/banks/add-bank';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WithdrawPage from './pages/withdrawals/withdraw';
import EarningsPage from './pages/earnings';

function App() {
  // const isLoggedIn = useSelector(state=>state.isLoggedIn);
  // console.log(isLoggedIn);

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="AppGlass">
        <BrowserRouter>
          <Sidebar />
          <Routes>
            <Route path="/" element={<MainDashboard />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/banks" element={<BankListPage />} />
            <Route path="/add-bank-account" element={<AddBankPage />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/update-password" element={<UpdatePassword />} />
            <Route path="/withdrawals" element={<Withdrawals />} />
            <Route path="/earnings" element={<EarningsPage />} />
            <Route path="/withdrawals/new" element={<WithdrawPage />} />
            <Route path="/investment-details/:transactionID" element={<InvestmentDetails />} />
          </Routes>
          {/* <RightSide /> */}
          <Footer />
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
